import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../../services/toast.service';

@Injectable()
export class ViewGroupNotificationPort {
	constructor(
		private toastService: ToastService,
		private translate: TranslateService
	) {}

	success(key: string): void {
		this.toastService.success(this.translate.instant(key));
	}

	error(key: string): void {
		this.toastService.error(this.translate.instant(key));
	}
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/view-group-notification.port.ts